import _ from 'lodash';
import React, { useEffect } from 'react';
import Immutable from 'immutable';
import act from '@flux/actions/actView';
import k from '@gral/constants';
import Misc from '@components/Misc';
import AddressesTable from './AddressesTable';
import NeedsManager from '@utils/NeedsManager';
import Error403 from '@components/Errors/403';
import { withTranslation } from 'react-i18next';
import { useSetState } from 'react-use';

const AddressesListAdd = props => {
  const type = props.type === 'item' ? 'v2/item' : props.type;

  const [state, setState] = useSetState({
    NOT_AUTHORIZED: false,
    _settedAddresses: Immutable.List(),
    _entity: undefined,
    _entityType: undefined,
    _entityTypeId: undefined,
    entityParams: props.data.getIn(['entityParams']),
  });

  //#region Functions

  const setStateAddressesEntity = entity => {
    if (entity) {
      switch (props.type) {
        case 'item':
          setState({
            _settedAddresses: __guard__(entity.getIn(['flavors', 'person', 'personData', 'xPersonDataAddresses']), x2 =>
              x2.map(xP => xP.get('address').set('addressType', xP.get('addressType')))
            ),
            _entity: entity,
            _entityType: 'personData',
            _entityTypeId: entity.getIn(['flavors', 'person', 'personData', 'id']),
          });
          break;
        case 'user':
          setState({
            _settedAddresses: __guard__(entity.getIn(['userPersonData', 'xPersonDataAddresses']), x3 =>
              x3.map(xP => xP.get('address').set('addressType', xP.get('addressType')))
            ),
            _entity: entity,
            _entityType: 'personData',
            _entityTypeId: entity.getIn(['userPersonData', 'id']),
          });

          break;
        case 'organization':
          setState({
            _settedAddresses: __guard__(entity.get('xOrganizationAddresses'), x4 =>
              x4.map(xP => xP.get('address').set('addressType', xP.get('addressType')))
            ),
            _entity: entity,
            _entityType: 'organization',
            _entityTypeId: entity.getIn(['id']),
          });
          break;
        default:
          console.log('UNKNOWN TYPE');
      }
    }
  };
  //#endregion

  useEffect(() => {
    const needs = [{ url: `/api/${type}/${props.xTypeId}`, dataPath: type + '_entity' }];
    new NeedsManager(props.data, needs).fetchNeeds();

    return () => {
      act.deleteResource(type + '_entity');
    };
  }, []);

  useEffect(() => {
    if (props.data.getIn([type + '_entity', 'data'])) {
      setStateAddressesEntity(props.data.getIn([type + '_entity', 'data']));
    }
  }, [props.data]);

  if (
    (state.entityParams != null ? state.entityParams.get('state') : undefined) === k.rsrcStates.IDLE &&
    __guard__(state.entityParams != null ? state.entityParams.get('errors') : undefined, x => x.size) > 0
  ) {
    const errors = _rsrc != null ? _rsrc.get('errors') : undefined;
    if (Array.isArray(errors.get('_gral')) && errors.get('_gral').indexOf('UNAUTHORIZED') === 0) {
      setState({ NOT_AUTHORIZED: true });
    }
  }

  if (state.NOT_AUTHORIZED === true) {
    return <Error403 />;
  }

  if (!state._entity) {
    return <Misc.Loading />;
  }

  return (
    <AddressesTable
      addresses={state._settedAddresses?.toJS()}
      title={'Addresses'}
      defaultCreationProperties={{
        entityType: state._entityType,
        xTypeId: state._entityTypeId,
      }}
    />
  );
};

export default withTranslation()(AddressesListAdd);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
